// extracted by css-extract-rspack-plugin
var _1 = "fc";
var _2 = "f9";
var _3 = "f6";
var _4 = "ga";
var _5 = "gb";
var _6 = "fe";
var _7 = "f7";
var _8 = "f8";
var _9 = "gc";
var _a = "e0";
var _b = "fh";
export { _1 as "descriptionBox", _2 as "discountCaption", _3 as "discountHeaderComponent", _4 as "discountTitle", _5 as "flyerTitle", _6 as "headerDescription", _7 as "itemButtonWrapper", _8 as "logoTileComponent", _9 as "pageDescription", _a as "title", _b as "validityText" }
